import React from 'react';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';
import { BannerStyle } from './styles';

interface PromoBannerProps {
  bg?: string;
  mobile?: string;
  overlay?: string;
}

export const PromoBanner = ({ bg, mobile, overlay }: PromoBannerProps) => {
  const loader = getThemeBrand().assets.loader;

  return (
    <BannerStyle
      $bg={bg}
      $mobile={mobile}
      $overlay={overlay}
      $loaderDefault={loader?.default}
      $loaderMobile={loader?.mobile}
    />
  );
};
